<script setup lang="ts">
import { onBeforeUpdate, onMounted, onUnmounted, ref, nextTick } from "vue";

import InvoiceDetail from "./InvoiceDetail.vue";

import type { Invoice } from "@/Modules/Models/Domain/Invoice";

import useInvoicesStore from "@/Modules/Invoices/Store";

export interface InvoicesWrapperProps {
  invoices: Invoice[];
}

const props = defineProps<InvoicesWrapperProps>();

const invoicesStore = useInvoicesStore();

const emit = defineEmits<{ (event: "showInvoice", value: string): void; (event: "loadMore"): void }>();

const observer = ref<IntersectionObserver | null>(null);

observer.value = new IntersectionObserver(
  async ([entry]) => {
    if (entry?.isIntersecting) {
      if (invoicesStore.nextPage) {
        emit("loadMore");

        observer.value?.disconnect();
      }
    }
  },
  { rootMargin: "25px" }
);

const startObserving = async () => {
  // Hacemos el nextTick para asegurar que los nuevos elementos se han pintado en el DOM
  await nextTick();

  const element = Array.from(document.querySelectorAll("#invoiceItem")).at(-1);
  observer.value?.observe(element as Element);
};

onBeforeUpdate(() => startObserving());

onMounted(() => startObserving());

onUnmounted(() => {
  observer.value?.disconnect();
});
</script>

<template>
  <InvoiceDetail
    v-for="invoice in props.invoices"
    id="invoiceItem"
    :invoice="invoice"
    :key="invoice.uuid"
    @selectInvoice="emit('showInvoice', $event)"
  />
</template>

<style scoped lang="scss"></style>
